import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import DotLoader from "../common/dotLoader";
import { chargeTypeIcon } from "utils/chargeTypeIcon";
import styles from "./priceListView.module.scss";
import PriceListViewModel from "viewModels/common/priceListViewModel";
import ReactMarkdown from "react-markdown";
import replaceLinkHost from "utils/replaceLinkHost";

export const PriceListView: ViewComponent<PriceListViewModel> = observer(({ vm }) => {
  if (!vm.isInitialized) {
    return (
      <div className="text-center">
        <DotLoader />
      </div>
    );
  }
  const chargeTypePrices = vm.chargeTypesWithPrices();

  return (
    <div>
      <h3 className="mb-6">{vm.translateTitle}</h3>
      <div className={styles.priceListWrapper}>
        <div className={styles.table}>
          {vm.fuelTypes.map(item => (
            <div key={item.id} className={styles.tableHeader}>
              <span>{vm.translateFuelType(item.fuelType)}</span>
              {vm.fuelTypeDescription(item.fuelType) && (
                <span className={vm.isDescriptionTooLong(item.fuelType) ? styles.small : styles.thin}>
                  <ReactMarkdown className="markdown">{replaceLinkHost(vm.fuelTypeDescription(item.fuelType)!)}</ReactMarkdown>
                </span>
              )}
            </div>
          ))}
        </div>
        <div className={styles.priceListItems}>
          {chargeTypePrices.map(chargeTypePrice => (
            <div key={chargeTypePrice.id} className={styles.priceListItem}>
              <div className={styles.imageWrapper}>
                <img className={styles.img} src={chargeTypeIcon(chargeTypePrice.validFor, vm.isCSLocale)} />
              </div>
              {chargeTypePrice.prices.map(item => (
                <div key={item.id} className={styles.priceWrapper}>
                  <div className={styles.priceHeader}>
                    <span>{vm.translateFuelType(item.fuelType)}</span>
                    {vm.fuelTypeDescription(item.fuelType) && (
                      <span className={vm.isDescriptionTooLong(item.fuelType) ? styles.small : styles.thin}>
                        <ReactMarkdown className="markdown">
                          {replaceLinkHost(vm.fuelTypeDescription(item.fuelType)!)}
                        </ReactMarkdown>
                      </span>
                    )}
                  </div>
                  <div className={styles.price}>{vm.formatPrice(item.price)}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

registerView(PriceListView, PriceListViewModel);
